<template>
  <c-modal
    class="c-blogPurchaseAlertForApp"
    :width="316"
    :active="isVisible"
    @close="$emit('close')"
  >
    <div class="c-blogPurchaseAlertForApp_title">アプリでは購入できません</div>
    <div class="c-blogPurchaseAlertForApp_text">ココナラのウェブサイトから購入いただいた後、このアプリでご覧ください。</div>
    <div slot="footer">
      <a class="c-blogPurchaseAlertForApp_close" @click="$emit('close')">
        閉じる
      </a>
    </div>
  </c-modal>
</template>
<script>
export default {
  name: 'BlogPurchaseAlertForApp',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogPurchaseAlertForApp {
  /deep/ .c-modal {
    &_header {
      display: none;
    }

    &_inner {
      background: #ededed;
    }
  }
  /deep/ .c-modal_footer {
    border-top: 1px solid $color-gray-200;
    padding: 8px;
  }

  &_title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  &_text {
    text-align: center;
    font-size: 14px;
    margin: 8px 16px 0;
  }

  &_close {
    text-align: center;
    display: block;
    color: #0072ff;
    font-size: 16px;
  }
}
</style>
